const messages = {
  box: {
    title: "Visibilità online",
  },
  title: "Visibilità online",
  description:
    "Aumentate e controllate la vostra visibilità digitale a livello di POS con UBERALL",
  category_title: "uberall - migliorare la visibilità digitale",
  category_description:
    "Utilizzate subito i vostri punti premio per portare il vostro marketing digitale di localizzazione al livello successivo. Con l'aiuto della piattaforma uberall, Bridgestone supporta i partner commerciali nell'ottimizzazione della loro presenza online per generare più visitatori. E questo su oltre 100 piattaforme come Google, Facebook, Bing o Trustpilot.",
  content: "Approfittate subito dei vantaggi uberall:",
  point1: "Ottimizzazione della visibilità online",
  point2: "Comoda gestione e controllo delle postazioni POS",
  point3:
    "Tracciare la visibilità locale, le valutazioni e i contenuti dei social media",
  footer:
    "Per informazioni dettagliate e una prima impressione di uberall, guardate il seguente video.",
  period: "Durata: 1 anno",
  form: {
    title: "Come utilizzare uberall per la vostra azienda:",
    point1: "Sottoscrivete un abbonamento annuale per 480 punti",
    point2: "Riceverete una conferma dopo un controllo interno",
    point3: "Nessun rinnovo automatico",
    pointDiscount: "Punti in un {price} CHF di per i seguenti",
    howMuch: "Quanti punti volete utilizzare?",
  },
  uberall: {
    title: "ABBONAMENTO UBERALL",
  },
  haveQuestion: "Avete una domanda?",
  contactUs: "Allora inviateci un'e-mail a",
};

export default {
  messages,
};
